"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FacilitiesCard = FacilitiesCard;
exports.facilities = void 0;
var _Card2 = _interopRequireDefault(require("@mui/material/Card"));
var _CardActions2 = _interopRequireDefault(require("@mui/material/CardActions"));
var _CardContent2 = _interopRequireDefault(require("@mui/material/CardContent"));
var _Typography2 = _interopRequireDefault(require("@mui/material/Typography"));
var _Skeleton2 = _interopRequireDefault(require("@mui/material/Skeleton"));
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _hooks = require("../hooks");
var _roadTypeBar = require("./road-type-bar");
var _roadTypeLegend = require("./road-type-legend");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const facilities = exports.facilities = [{
  key: 'recommendedRoads',
  color: _hooks.facilityDistributionColors.recommended,
  labelKey: 'commons.facilities_legend.dedicated_roads',
  descriptionKey: 'commons.facilities_legend.dedicated_roads_description'
}, {
  key: 'normalRoads',
  color: _hooks.facilityDistributionColors.normal,
  labelKey: 'commons.facilities_legend.shared_roads',
  descriptionKey: 'commons.facilities_legend.shared_roads_description'
}, {
  key: 'discouragedRoads',
  color: _hooks.facilityDistributionColors.discouraged,
  labelKey: 'commons.facilities_legend.other_routes',
  descriptionKey: 'commons.facilities_legend.other_roads_description'
}];
function FacilitiesCard({
  size,
  layout,
  route,
  actions,
  ...props
}) {
  const {
    t
  } = (0, _reactI18next.useTranslation)();
  return /*#__PURE__*/_react.default.createElement(_Card2.default, _extends({}, props, {
    sx: {
      ...props.sx,
      borderRadius: 4,
      width: layout === 'row' ? 'calc((100% - 16px) / 2)' : '100%'
    },
    variant: "outlined"
  }), /*#__PURE__*/_react.default.createElement(_CardContent2.default, {
    sx: {
      '&&': {
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
        padding: 2
      }
    }
  }, /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    fontSize: size === 'small' ? '1rem' : '1.1rem',
    fontWeight: 600
  }, route ? t('commons.routing.distances.cycling_roads', {
    value: route.recommendedRoadsPercentage
  }) : /*#__PURE__*/_react.default.createElement(_Skeleton2.default, {
    variant: "text",
    width: 150
  })), /*#__PURE__*/_react.default.createElement(_roadTypeBar.RoadTypeBar, {
    entries: facilities,
    values: route ? [route.recommendedRoadsPercentage, route.normalRoadsPercentage, route.discouragedRoadsRoadsPercentage] : undefined
  }), /*#__PURE__*/_react.default.createElement(_roadTypeLegend.RoadTypeLegend, {
    entries: facilities
  })), actions && /*#__PURE__*/_react.default.createElement(_CardActions2.default, null, actions));
}